const Clock = ({
	size = 16,
	color = "#142D36",
	bgColor = "#FFF",
}: {
	size?: number;
	color?: string;
	bgColor?: string;
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 16 16"
		style={{ background: bgColor }}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.664062 7.99984C0.664062 3.94965 3.94721 0.666504 7.9974 0.666504C12.0476 0.666504 15.3307 3.94965 15.3307 7.99984C15.3307 12.05 12.0476 15.3332 7.9974 15.3332C3.94721 15.3332 0.664062 12.05 0.664062 7.99984ZM7.9974 1.99984C4.68359 1.99984 1.9974 4.68603 1.9974 7.99984C1.9974 11.3136 4.68359 13.9998 7.9974 13.9998C11.3112 13.9998 13.9974 11.3136 13.9974 7.99984C13.9974 4.68603 11.3112 1.99984 7.9974 1.99984Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8.0026 3.33301C8.37079 3.33301 8.66927 3.63148 8.66927 3.99967V7.72656L11.3004 10.358C11.5607 10.6183 11.5607 11.0404 11.3003 11.3008C11.0399 11.5611 10.6178 11.5611 10.3575 11.3007L7.53117 8.47405C7.40616 8.34903 7.33594 8.17947 7.33594 8.00267V3.99967C7.33594 3.63148 7.63441 3.33301 8.0026 3.33301Z"
			fill={color}
		/>
	</svg>
);

export default Clock;
